import RmCardsGroup from '../rm-cards-group/RmCardsGroup';
import styles from './RmCardsGroupSeries.module.scss';
import PropTypes from 'prop-types';
import { RMCardGroupDataType } from 'types/types';

const RmCardsTwinGroupContainer = (props) => {
    const {
        titleOne,
        titleTwo,
        subTitleOne,
        subTitleTwo,
        upperRightContentOne,
        upperRightContentTwo,
        footerOne,
        footerTwo,
        groupOneData,
        groupTwoData,
        groupOneTooltipType,
        groupTwoTooltipType,
        groupOneDataType = RMCardGroupDataType.Default,
        groupTwoDataType = RMCardGroupDataType.Default,
        isBottomGroup,
        navigateTo
    } = props;
    return (
        <div className={styles.twinGroupContainer}>
            <div className={styles.cardsContainer}>
                <RmCardsGroup
                    title={titleOne}
                    subTitle={subTitleOne}
                    upperRightContent={upperRightContentOne}
                    footerText={footerOne}
                    isLeftGroup
                    data={groupOneData}
                    dataType={groupOneDataType}
                    tooltipType={groupOneTooltipType}
                    isBottomGroup={isBottomGroup}
                    navigateTo={navigateTo}
                />
                <RmCardsGroup
                    title={titleTwo}
                    subTitle={subTitleTwo}
                    upperRightContent={upperRightContentTwo}
                    footerText={footerTwo}
                    isRightGroup
                    data={groupTwoData}
                    dataType={groupTwoDataType}
                    tooltipType={groupTwoTooltipType}
                    isBottomGroup={isBottomGroup}
                    navigateTo={navigateTo}
                />
            </div>
        </div>
    );
};

RmCardsTwinGroupContainer.propTypes = {
    titleOne: PropTypes.string.isRequired,
    titleTwo: PropTypes.string.isRequired,
    subTitleOne: PropTypes.string.isRequired,
    subTitleTwo: PropTypes.string.isRequired,
    upperRightContentOne: PropTypes.element,
    upperRightContentTwo: PropTypes.element,
    footerOne: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
        .isRequired,
    footerTwo: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
        .isRequired,
    groupOneData: PropTypes.any,
    groupTwoData: PropTypes.any,
    groupOneDataType: PropTypes.oneOf([
        'default',
        'topFiveRms',
        'topFiveEmergingModerateRm',
        'topFiveEmergingMajorRm',
        'topFiveRmsSpike',
        'alerts'
    ]).isRequired,
    groupTwoDataType: PropTypes.oneOf([
        'default',
        'topFiveRms',
        'topFiveEmergingModerateRm',
        'topFiveEmergingMajorRm',
        'topFiveRmsSpike',
        'alerts'
    ]).isRequired,
    groupOneTooltipType: PropTypes.oneOf([
        'default',
        'scoreDecomposition',
        'trendAnalysis'
    ]),
    groupTwoTooltipType: PropTypes.oneOf([
        'default',
        'scoreDecomposition',
        'trendAnalysis'
    ]),
    isBottomGroup: PropTypes.bool,
    navigateTo: PropTypes.func
};

export default RmCardsTwinGroupContainer;
